import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>API Keys</Typography>

        <p>API Keys are used to access the Smartix API. If you have multiple applications that need to access our API, then create a separate set of keys for each of your applications.</p>

        <p>API Keys are are issued as pairs. A TEST and a LIVE key. When you use a TEST key to make a wallet pass then a TEST pass will be created. When you use a LIVE key to make a wallet pass then a LIVE pass will be created. For all other operations you should use the LIVE key.</p>

        <p>If you believe a key may have been compromised, then please create a new key, update your system then delete the compromised key. You can also temporarily disable a set of keys</p>

    </div>
  )
}

export default HelpText